import { render } from "./TituloProcesosNew.vue?vue&type=template&id=541d90c5&scoped=true"
import script from "./TituloProcesosNew.vue?vue&type=script&lang=js"
export * from "./TituloProcesosNew.vue?vue&type=script&lang=js"

import "./TituloProcesosNew.vue?vue&type=style&index=0&id=541d90c5&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541d90c5"]])

export default __exports__